import {NgZone} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProjectEntity} from '@spout/global-any/models';
import {aggregateDocChanges, firestoreChatsPath} from '@spout/global-web/fns';
import {
  AccountState,
  AggregateFirebaseSnapshotChangesEntities,
  ChatEntity
} from '@spout/global-web/models';
import {
  DocumentChange,
  DocumentData,
  onSnapshot,
  QuerySnapshot
} from '@firebase/firestore';
import {deleteChats, upsertChats} from '../../+chat/chat.actions';
import {CustomFirestoreService} from '../../firebase';
import {QueryModel} from './query.model';

export class QueryChatsService implements QueryModel<ChatEntity> {
  // TRACK
  private myChatsSub: (() => void) | undefined;
  constructor(
    private sptFirebase: CustomFirestoreService,
    private store: Store,
    private config: ProjectEntity,
    private zone: NgZone
  ) {}

  onConnect(user: AccountState) {
    const that = this;

    // BEGIN TRACKS
    if (this.myChatsSub) {
      this.myChatsSub();
    }

    this.myChatsSub = onSnapshot(
      this.sptFirebase.collectionRef(firestoreChatsPath(this.config)),
      (snapshot: QuerySnapshot) => {
        // that.processTracks(snapshot, user.auth.uid);
        that.process.apply(that, [snapshot.docChanges()]);
      },
      () => {
        /* noop */
      },
      () => {
        /* noop */
      }
    );
  }

  onDisconnect(user?: AccountState) {
    // TRACKS
    if (this.myChatsSub) {
      this.myChatsSub();
    }
  }

  process(snapshot: DocumentChange<DocumentData>[]) {
    const that = this;
    const aggregate: AggregateFirebaseSnapshotChangesEntities<DocumentData> =
      aggregateDocChanges<DocumentData>(
        snapshot
        // createdByUID
      );

    this.zone.run(() => {
      if (aggregate.added.length) {
        // aggregate.added.forEach((added) => {
        //   console.log('TRACKS ADDED', added.id);
        // });

        that.store.dispatch(
          upsertChats({
            chats: <ChatEntity[]>aggregate.added
          })
        );
      }

      if (aggregate.modified.length) {
        // aggregate.modified.forEach((modified) => {
        //   console.log('TRACKS MODIFIED', modified.id);
        // });

        that.store.dispatch(
          upsertChats({
            chats: <ChatEntity[]>aggregate.modified
          })
        );
      }

      if (aggregate.removed.length) {
        // aggregate.removed.forEach((removed) => {
        //   console.log('TRACKS REMOVED', removed);
        // });

        that.store.dispatch(
          deleteChats({
            ids: aggregate.removed
          })
        );
      }
    });
  }
}
